<div class="team-cardlist">
  <div class="team-list">
    <div class="group-container" [ngStyle]="{ 'background-color': color }">
      <mat-icon>group</mat-icon>
    </div>
    <div class="team-info">
      <div class="team-name">{{ team?.team_name || '-' }}</div>
      <div class="members-container">
        <button mat-button [matMenuTriggerFor]="menu" (click)="getTeamMembers()">
          <span class="members-label" l10nTranslate> shared.viewMembers </span>
          <mat-icon>arrow_drop_down</mat-icon>
        </button>
        <mat-menu #menu="matMenu" class="members-menu" xPosition="after" yPosition="below">
          <button mat-menu-item *ngFor="let member of teamMembers$ | async">
            {{ member?.first_name }} {{ member?.last_name }}
          </button>
        </mat-menu>
      </div>
    </div>
    <div class="assign-bgcolor" [ngClass]="{ 'miq-only': isOnMIQ }">
      <div class="assign-check">
        <div>
          <mat-checkbox [checked]="selected" (change)="onClick($event.checked)"></mat-checkbox>
        </div>
        <div *ngIf="isOnMIQ != null" class="contactcard-icon">
          <label *ngIf="isOnMIQ" class="miq-icon" l10nTranslate>shared.miq</label>
        </div>
      </div>
    </div>
  </div>
</div>
